export const STRIPE_PUBLISHABLE_KEY =
  'pk_test_51JtSdLDKl5ScvvTeq3PAXEPFwAqDSKdRMpfz5OwQ0xeyDtNMwjM1vcZ5iynPAhPjCl6VBfdnW9v4WDs12itxvUlo009DvgTqty';
